/* eslint-disable import/no-cycle */
import PropTypes from 'prop-types';
import { CALENDAR } from '../../../../brands/default/content/components/deal';
import DealBuyButton from '../buy-buttons/DealBuyButton';
import DealGiftButton from '../buy-buttons/DealGiftButton';
import DealViewAvailabilityButton from '../buy-buttons/DealViewAvailabilityButton';

export const getBuyButtonDeal = ({
  selection,
  deal,
  convertBookingProductToBasketProduct,
  quantity,
  deposit,
  flights,
}) =>
  selection
    ? {
        ...deal,
        products: [
          convertBookingProductToBasketProduct(
            deal,
            selection,
            quantity,
            deposit,
            flights,
          ),
        ],
      }
    : null;

export const CalendarBuyButtons = ({
  isBookingCalendarOnRedemption,
  isGift,
  buyButtonDeal,
  isButtonClickValid,
}) => (
  <>
    {!isGift && (
      <DealBuyButton
        className="buy-button margin size-larger full-width"
        deal={buyButtonDeal}
        isValidExternal={isButtonClickValid}
        text={
          isBookingCalendarOnRedemption ? CALENDAR.BUY_EXCL : CALENDAR.PROCEED
        }
      />
    )}
    {isGift && (
      <DealGiftButton
        className="gift-button margin size-larger full-width"
        deal={buyButtonDeal}
        isValidExternal={isButtonClickValid}
        text={CALENDAR.PROCEED}
      />
    )}
  </>
);

export const TravelCalendarBuyButtons = ({
  isBookingCalendarOnRedemption,
  isBookingCalendarOnRedemptionGift,
  isGiftable,
  buttonRef,
  buyButtonDeal,
  deal,
  isButtonClickValid,
  deposit,
  isGoogleHotel,
  searchParams,
  setGiftingClearSelection,
}) => (
  <>
    <DealBuyButton
      buttonRef={buttonRef}
      className="buy-button margin size-xlarge full-width"
      deal={buyButtonDeal}
      isValidExternal={isButtonClickValid}
      text={
        deposit
          ? CALENDAR.RESERVE_CHECKOUT
          : isBookingCalendarOnRedemption
          ? CALENDAR.BUY_EXCL
          : CALENDAR.PROCEED
      }
    />
    {isGiftable && (
      <>
        {(deal?.display?.dynamicTravelDeal ||
          isBookingCalendarOnRedemptionGift) && (
          <>
            <DealViewAvailabilityButton
              className="full-width"
              deal={deal}
              gift
              isGoogleHotel={isGoogleHotel}
              searchParams={searchParams}
              setGiftingClearSelection={setGiftingClearSelection}
            />
          </>
        )}
        {!isBookingCalendarOnRedemptionGift &&
          !deal?.display?.dynamicTravelDeal && (
            <>
              <DealGiftButton
                className="gift-button size-larger full-width outline margin"
                deal={buyButtonDeal}
                isValidExternal={isButtonClickValid}
                text={CALENDAR.GIVE_AS_A_GIFT}
              />
            </>
          )}
      </>
    )}
  </>
);

CalendarBuyButtons.propTypes = {
  buyButtonDeal: PropTypes.object,
  isBookingCalendarOnRedemption: PropTypes.bool,
  isButtonClickValid: PropTypes.bool,
  isGift: PropTypes.bool,
};

TravelCalendarBuyButtons.propTypes = {
  buttonRef: PropTypes.any,
  buyButtonDeal: PropTypes.object,
  deal: PropTypes.object,
  deposit: PropTypes.any,
  isBookingCalendarOnRedemption: PropTypes.bool,
  isBookingCalendarOnRedemptionGift: PropTypes.bool,
  isButtonClickValid: PropTypes.bool,
  isGiftable: PropTypes.bool,
  isGoogleHotel: PropTypes.bool,
  searchParams: PropTypes.object,
};
